import React from 'react';
import { Logo } from './Logo';
export function SiteFooter() {
  return <footer className="bg-navy-deep pb-32 pt-16 text-paper md:pb-16" data-id="element-94" data-mp="3r89dd8j06tgf">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-95" data-mp="3r918ki8oup66">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-96" data-mp="3mgrdknspuyx1">
          <div data-id="element-97" data-mp="3hizijkwrywom">
            <a href="/" aria-label="Veterans For Life home" className="inline-block" data-id="element-98" data-mp="3hhet29pbi3xm">
              <Logo data-id="element-99" data-mp="3dh4kcpa54zf2" />
            </a>
            <p className="mt-5 text-lg text-paper/80" data-id="element-100" data-mp="3di5wyy6t1tyw">Veterans helping veterans.</p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 sm:gap-16" data-id="element-101" data-mp="38ggj7as77274">
            <nav aria-label="Footer" data-id="element-102" data-mp="33hvmhlc5n0nf">
              <ul className="space-y-3" data-id="element-103" data-mp="33ix4k9rl8nen">
                <li data-id="element-104" data-mp="2yk3rgig7qyf0">
                  <a href="/faq" className="text-lg text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-105" data-mp="2ykna61dotqu3">
                    FAQ
                  </a>
                </li>
                <li data-id="element-106" data-mp="wrz5dnleavc7">
                  <a href="/contact-us" className="text-lg text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-107" data-mp="wtii547ueo98">
                    Contact Us
                  </a>
                </li>
              </ul>
            </nav>
            <address className="space-y-3 not-italic text-lg text-paper/90" data-id="element-108" data-mp="1anlqzv0int4b">
              <p data-id="element-109" data-mp="vuijkggn2vrb">[PHONE]</p>
              <p data-id="element-110" data-mp="10rsgeh6cy9p6">[EMAIL]</p>
            </address>
          </div>
        </div>

        <div aria-hidden="true" className="mt-12 h-px w-full bg-gold/30" data-id="element-111" data-mp="10tv4gvny9sr9" />

        <p className="mt-8 max-w-4xl text-sm leading-relaxed text-paper/70" data-id="element-112" data-mp="1ohv4ynb2cxj1">
          Veterans For Life is a private company. We are not affiliated with, endorsed by, or accredited through the
          U.S. Department of Veterans Affairs. Free claims assistance is available through accredited Veterans
          Service Organizations.
        </p>
        <p className="mt-4 text-sm text-paper/60" data-id="element-113" data-mp="27gh43wn0sekb">© {new Date().getFullYear()} Veterans For Life</p>
      </div>
    </footer>;
}